import React from 'react';

const FormContainer = ({ children }) => (
  <div style={{ maxWidth: 500, marginLeft: 'auto', marginRight: 'auto' }}>{children}</div>
);

export default FormContainer;
